import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable()
export class ManageCarrierService {
  readonly carrierStateDeleted = new Subject<void>();
}
